import React, {useContext, useEffect, useState} from 'react';
import "./Home.scss"
import {getUserOrganizationsWithNotesAndCourses, getUserSignDocsAPI} from "../../Services/api";
import {map} from "lodash";
import {FAQs} from "../FAQ/Faq";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import {useLearningCenterLib} from "../../LearningCenter/LearningCenterLib";
import {PageTitle} from "../PageTitle/PageTitle";
import {getUniqNotes} from "./HomeLib";
import {Note} from "../Note/Note";
import {PieChart} from "../Charts/PieChart/PieChart";
import {getAllSignDocTypes} from "../SignDoc/SignDocLib";
import {SignDocsListWithFilters} from "../LearningManagement/SignDocsListWithFilters/SignDocsListWithFilters";
import {I18nReactContext} from "../../contexts/I18nContext";
import {UserReactContext} from "../../contexts/UserContext";
import {CompanyReactContext} from "../../contexts/CompanyContext";
import {FirstLoginModal} from "../Login/FirstLoginModal/FirstLoginModal";
import {SignDocCategories} from "../../Utils/Constants";

export const UsersHome = () => {
    const {i18n} = useContext(I18nReactContext);
    const userContext = useContext(UserReactContext);
    const {companyName} = useContext(CompanyReactContext);
    const {userChartLabels, calcUserChartData} = useLearningCenterLib();
    const [organizations, setOrganizations] = useState()
    const [signDocs, setSignDocs] = useState()
    const [userChartData, setUserChartData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [notes, setNotes] = useState([])
    const [showFirstLoginModal, setShowFirstLoginModal] = useState(false)

    const onCloseFirstLoginModal = () => {
        setShowFirstLoginModal(false)
    }

    const init = async () => {
        setIsLoading(true)
        const signDocs = await getUserSignDocsAPI({
            types: getAllSignDocTypes(),
            categories: [SignDocCategories.FORCE_COMPLETION, SignDocCategories.CERTIFICATION],
            hideLearningPathItems: true
        })
        setSignDocs(signDocs)
        await isFirstLogin()
        const newChartData = calcUserChartData({signDocs})
        //if all values of chartData are empty
        if (newChartData[0] === 0 && newChartData[1] === 0 && newChartData[2] === 0) {
            setUserChartData(null)
        } else {
            setUserChartData(newChartData)
        }
        setIsLoading(false)
    }

    const isFirstLogin = async () => {
        const firstLoginDate = await userContext.getFirstLoginDate()
        if ( !firstLoginDate){
            setShowFirstLoginModal(true)
        } else {
            setShowFirstLoginModal(false)
        }
    }

    const fetchOrgs = async () => {
        let orgs = await getUserOrganizationsWithNotesAndCourses({})
        const notes = getUniqNotes({orgs})
        setNotes(notes)
        setOrganizations(orgs)
    }

    useEffect(() => {
        fetchOrgs()
        init()
    }, []);

    // Transform chart data for PieChart component
    const transformChartDataForPieChart = () => {
        if (!userChartData || !userChartLabels) return [];
        
        return userChartLabels.map((label, index) => ({
            label: label,
            value: userChartData[index] || 0
        }));
    };

    return <div className="home MenuPage">
        {showFirstLoginModal ?  <FirstLoginModal openFirstLoginModal={true} closeFirstLoginModal={onCloseFirstLoginModal}/> : null }
        <PageTitle
            title={i18n.translate('home.welcome')}
            subTitle={i18n.translate('home.learningSubtitle')}
            subTitleBold={companyName}/>
        <div className="menuInnerPage">
            <div className="homeContent">
                {userChartData || (notes && notes.length) ? <div className="homeNotesRow">
                    {notes ? <div className="Notes">
                        {
                            map(notes, (note, index) => {
                                return <Note note={note} key={note.id}/>
                            })
                        }

                    </div> : ''}
                    {userChartData ? <div className="Chart">
                        {isLoading ? <LoadingSpinner/> :
                            <PieChart 
                                data={transformChartDataForPieChart()}
                                variant="doughnut"
                                showPercentages={true}
                                excludeZeroValues={false}
                                showLegend={true}
                                height={350}    
                                labelText={''}
                            />
                        }
                    </div> : ""}
                </div> : ''}

                <div className="openTasksWrapper">
                    <div className="PageSecondaryTitle">{i18n.translate('learningCenter.tabs.myTasks')}</div>
                    <SignDocsListWithFilters showOnlyUncompletedTasks={true} isUserView={true} />
                </div>
                <div className="FAQWrapper">
                    <div className="FAQ">
                        <div className="PageSecondaryTitle">{i18n.translate('home.faq')}</div>
                        <div className="FAQData">
                            <FAQs/>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
}

